if (!customElements.get('impulse-size-guide-drawer')) {
  customElements.define(
    'impulse-size-guide-drawer',
    class ImpulseSizeGuideDrawer extends HTMLElement {
      constructor() {
        super();
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onOverlayClick = this.onOverlayClick.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
        this.onTriggerClick = this.onTriggerClick.bind(this);
      }

      connectedCallback() {
        if (this.dataset.mounted === 'true') return;
        this.dataset.mounted = 'true';

        if (!this.id) {
          this.id = `SizeGuideDrawer-${Date.now()}`;
        }

        this.overlay = this.querySelector('.impulse-size-guide-drawer__overlay');
        this.panel = this.querySelector('.impulse-size-guide-drawer__panel');
        this.closeButton = this.querySelector('.impulse-size-guide-drawer__close');

        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
        }

        if (this.overlay) {
          this.overlay.addEventListener('click', this.onOverlayClick);
        }

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.onCloseClick);
        }

        this.bindTriggers();
      }

      bindTriggers() {
        document.querySelectorAll(`[data-size-guide-open="${this.id}"]`).forEach((trigger) => {
          if (trigger.dataset.sizeGuideBound === this.id) return;
          trigger.dataset.sizeGuideBound = this.id;
          trigger.addEventListener('click', this.onTriggerClick);
        });
      }

      onTriggerClick(event) {
        event.preventDefault();
        this.show(event.currentTarget);
      }

      onCloseClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.hide();
      }

      onOverlayClick(event) {
        event.preventDefault();
        this.hide();
      }

      onKeyUp(event) {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      }

      show(focusElement) {
        this.bindTriggers();
        this.removeAttribute('hidden');
        this.setAttribute('open', '');
        this.focusElement = focusElement;
        if (this.focusElement) this.focusElement.setAttribute('aria-expanded', 'true');

        document.body.classList.add('impulse-size-guide-drawer-open');
        document.addEventListener('keyup', this.onKeyUp);

        requestAnimationFrame(() => {
          if (typeof trapFocus === 'function' && this.panel) {
            trapFocus(this.panel, this.closeButton || this.panel);
          } else if (this.panel) {
            this.panel.focus();
          }
        });
      }

      hide() {
        if (!this.hasAttribute('open')) return;

        this.removeAttribute('open');
        this.setAttribute('hidden', '');

        if (this.focusElement) {
          this.focusElement.setAttribute('aria-expanded', 'false');
          if (typeof removeTrapFocus === 'function') {
            removeTrapFocus(this.focusElement);
          }
          this.focusElement.focus();
        }

        document.body.classList.remove('impulse-size-guide-drawer-open');
        document.removeEventListener('keyup', this.onKeyUp);
      }
    }
  );
}
